import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import './App.css'
import { useAuth } from './AuthContext';
import { useIsAuthenticated, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import ServiceNowTickets from './components/ServiceNowTickets';
import SalesforceLeads from './components/SalesforceLeads';
import SalesforceInventory from './components/SalesforceInventory';

function App() {
  const { login, logout, user, inProgress } = useAuth();
  const isAuthenticated = useIsAuthenticated();

  if (inProgress === "login" || (!isAuthenticated && !inProgress)) {
    return (
      <div className="loading-container">
        <div className="loading-content">
          <h2>Authenticating...</h2>
          <p>Please wait while we securely log you in.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <header>
        <div className="header-content">
          <h1>XperienceAI - Vision Intelligence</h1>
          <AuthenticatedTemplate>
            <div className="auth-controls">
              <span>Welcome, {user?.name}</span>
              <button onClick={logout}>Sign Out</button>
            </div>
          </AuthenticatedTemplate>
        </div>
      </header>

      <AuthenticatedTemplate>
        <main className="main-content">
          <Tabs>
            <TabList className="react-tabs__tab-list">
              <Tab>ServiceNow Tickets</Tab>
              <Tab>Salesforce Inventory</Tab>
              <Tab>Salesforce Leads</Tab>
            </TabList>

            <TabPanel>
              <ServiceNowTickets />
            </TabPanel>
            <TabPanel>
              <SalesforceInventory />
            </TabPanel>
            <TabPanel>
              <SalesforceLeads />
            </TabPanel>
          </Tabs>
        </main>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <div className="loading-container">
          <div className="loading-content">
            <h2>Redirecting to login...</h2>
            <p>If you are not redirected automatically, <button onClick={login}>click here</button></p>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
}

export default App;
